import {REST_METHODS} from '@/src/app/constants/api';
import {
  ORDER_BY_FILTER,
  ORDER_FILTER,
  SEARCH_FILTERS,
} from '@/src/app/constants/search';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const COURSES_PER_PAGE = 10;

const fetchCoursesForUnitedTab = ({searchQuery, locale}) => {
  // @ts-ignore
  return unauthorizedFetch({
    method: REST_METHODS.GET,
    path: `/api/v1/courses/search`,
    queryParams: [
      {
        name: SEARCH_FILTERS.LANGUAGE,
        value: locale,
      },
      {
        name: SEARCH_FILTERS.SEARCH,
        value: searchQuery,
      },
      {
        name: SEARCH_FILTERS.PER_PAGE,
        value: COURSES_PER_PAGE,
      },
      {
        name: SEARCH_FILTERS.ORDER_BY,
        value: ORDER_BY_FILTER.APPROVED_AT,
      },
      {
        name: SEARCH_FILTERS.ORDER,
        value: ORDER_FILTER.DESC,
      },
    ],
  });
};

export default fetchCoursesForUnitedTab;
